export const MASS = {
  SEND_TYPE: {
    MASS: 1,
    BROADCAST: 2,
    TEMPLATE: 3,
    SMS: 4,
    TIMING_OUT_SEND: 5,
    WxSubTp: 6,
  },
  RIGHTS: {
    MASS: 'broadcast', // 兼容历史群发权限
    BROADCAST: 'broadcasts',
    SMS: 'sms',
    TEMPLATE_SEND: 'templateSend',
    TIMING_OUT_SEND: 'timing_out_send',
  },
  REFRESH_AUTH_STATUS: {
    SAME: 0,
    NORMAL: 1,
    DIFF: 2,
  },
  RIGHTS_TYPE: {
    MASS: 1,
    REPLACE_SUPER: 2,
    BROADCAST: 3,
    BOOKING_NOTIFY: 4,
    SMS: 5,
    TEMPLATE_SEND: 6,
  },
};
